export const wantedConstants ={
    
    SAVE_WANTEDTYPE_REQUEST:'SAVE_WANTEDTYPE_REQUEST',
    SAVE_WANTEDTYPE_SUCCESS:'SAVE_WANTEDTYPE_SUCCESS',
    SAVE_WANTEDTYPE_FAILURE:'SAVE_WANTEDTYPE_FAILURE',

    GET_WANTEDTYPE_REQUEST:'GET_WANTEDTYPE_REQUEST',
    GET_WANTEDTYPE_SUCCESS:'GET_WANTEDTYPE_SUCCESS',
    GET_WANTEDTYPE_FAILURE:'GET_WANTEDTYPE_FAILURE',

    UPDATE_WANTEDTYPE_REQUEST:'UPDATE_WANTEDTYPE_REQUEST',
    UPDATE_WANTEDTYPE_SUCCESS:'UPDATE_WANTEDTYPE_SUCCESS',
    UPDATE_WANTEDTYPE_FAILURE:'UPDATE_WANTEDTYPE_FAILURE',

    GET_WANTED_BY_ID_REQUEST:'GET_WANTED_BY_ID_REQUEST',
    GET_WANTED_BY_ID_SUCCESS:'GET_WANTED_BY_ID_SUCCESS',
    GET_WANTED_BY_ID_FAILURE:'GET_WANTED_BY_ID_FAILURE',

    
    GET_WANTED_REQUEST:'GET_WANTED_REQUEST',
    GET_WANTED_SUCCESS:'GET_WANTED_SUCCESS',
    GET_WANTED_FAILURE:'GET_WANTED_FAILURE',

    SAVE_LICENSE_REQUEST:'SAVE_LICENSE_REQUEST',
    SAVE_LICENSE_SUCCESS:'SAVE_LICENSE_SUCCESS',
    SAVE_LICENSE_FAILURE:'SAVE_LICENSE_FAILURE',

    SAVE_VEHICLE_REQUEST:'SAVE_VEHICLE_REQUEST',
    SAVE_VEHICLE_SUCCESS:'SAVE_VEHICLE_SUCCESS',
    SAVE_VEHICLE_FAILURE:'SAVE_VEHICLE_FAILURE',

    SAVE_MOBILE_REQUEST:'SAVE_MOBILE_REQUEST',
    SAVE_MOBILE_SUCCESS:'SAVE_MOBILE_SUCCESS',
    SAVE_MOBILE_SUCCESS:'SAVE_MOBILE_SUCCESS',
    
}